export const COUNTDOWN_PARAM_HASH = 'BIGON_PRODUCT_COUNTDOWN';
export const ALTERNATIVE_PRODUCTS_CROSSSALE_HASH = 'BIGON_ALTERNATIVE_PRODUCTS';